<template>
  <div v-if="invalid == false">
    <h3>{{appnum}} Aggregation Results</h3>
    <Input :inputField="pass" inputName="Access Code" inputType="pass"  @enter="authenticate" v-if="!passw"/>
    <div class="buttons is-right">
      <!-- <a class="button is-link is-inverted padded-button next-button">Skip</a> -->
      <a class="button is-link padded-button next-button" :class="loading ? 'is-loading' : ''" @click="authenticate">Continue</a>
    </div>
  </div>
  <div v-else>
    <h3>Error!</h3>
  </div>
</template>

<script>
import $ from 'jquery'
import Input from '@/components/shared/Input'
export default {
  name: 'AggLoading',
  components: {
    Input
  },
  props: {
    link: String,
    passw: String,
    token: String
  },
  data () {
    return {
      invalid: false,
      pass: Input.model(),
      dealname: null,
      loading: true,
      appnum: null,
      accounts: null,
      reports: null,
      decisions: null,
      custid: null,
      userdata: null,
      tokenval: null,
      files: null,
      plaidmodel: null
    }
  },
  methods: {
    next () {
      this.$emit('next', this.$data)
      console.log(this.$data)
    },
    authenticate(token = null) {
      if (this.loading){
        return
      }
      var self = this
      self.loading = true
      let data = JSON.stringify({ link: this.link, pass: this.pass.value, appnum: this.appnum })
      if (this.token){
        self.tokenval = this.token
        data = JSON.stringify({ link: this.link, pass: this.pass.value, token: this.token, appnum: this.appnum })
      }

      $.ajax({
        type: 'POST',
        url: '/api/aggregation/get-accounts',
        contentType: 'application/json',
        dataType: 'json',
        data: data
      }).done(function (response) {
        console.log(response.accounts)
        self.accounts = response.accounts
        self.reports = response.reports
        self.decisions = response.decisions
        self.custid = response.custid
        self.files = response.files
        if (response.userdata){
          self.userdata = response.userdata
        }
        self.plaidmodel = response.plaid_model
        self.next()
      }).fail(function (err) {
        console.log(err.responseText)
        alert(err.responseText)
        self.invalid = true
        localStorage.removeItem('authtoken')
      })
    }
  },
  mounted: function () {
    var self = this 
    $.ajax({
      type: 'POST',
      url: '/api/aggregation/verify-link',
      contentType: 'application/json',
      dataType: 'json',
      data: JSON.stringify({ link: this.link })
    }).done(function (response) {
      self.appnum = response.appnum
      self.loading = false
      const link = self.link
      if(self.passw){
        // authenticate with the url in the string 
        self.pass.value = self.passw
        // self.$router.replace('decisions/')
        self.$router.push({ path: `/decisions/${link}` })
        self.authenticate(self.token)
      }

    }).fail(function (err) {
      console.log(err.responseText)
      console.log('invalid link!')
      self.invalid = true
    })
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
